var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8001 4.60006C19.1314 4.15823 19.0419 3.53143 18.6001 3.20006C18.1582 2.86869 17.5314 2.95823 17.2001 3.40006L5.20006 19.4001C4.86869 19.8419 4.95823 20.4687 5.40006 20.8001C5.84189 21.1314 6.46869 21.0419 6.80006 20.6001L18.8001 4.60006Z",
    fill: "#3266BB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 10.0001C8.433 10.0001 10 8.43306 10 6.50006C10 4.56706 8.433 3.00006 6.5 3.00006C4.567 3.00006 3 4.56706 3 6.50006C3 8.43306 4.567 10.0001 6.5 10.0001ZM6.5 8.00006C7.32843 8.00006 8 7.32849 8 6.50006C8 5.67163 7.32843 5.00006 6.5 5.00006C5.67157 5.00006 5 5.67163 5 6.50006C5 7.32849 5.67157 8.00006 6.5 8.00006Z",
    fill: "#3266BB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5 21.0001C19.433 21.0001 21 19.4331 21 17.5001C21 15.5671 19.433 14.0001 17.5 14.0001C15.567 14.0001 14 15.5671 14 17.5001C14 19.4331 15.567 21.0001 17.5 21.0001ZM17.5 19.0001C18.3284 19.0001 19 18.3285 19 17.5001C19 16.6716 18.3284 16.0001 17.5 16.0001C16.6716 16.0001 16 16.6716 16 17.5001C16 18.3285 16.6716 19.0001 17.5 19.0001Z",
    fill: "#3266BB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscount);
export default __webpack_public_path__ + "static/media/discount.d4c7982504f415c9ba44b11dc35f13eb.svg";
export { ForwardRef as ReactComponent };